module.exports = __webpack_public_path__ + "static/assets/30d09ba32a17082ef820b57d52d60b7b.hex";